// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__kBSG4","closeButton":"modal_closeButton__vHois","dialog":"modal_dialog__R3O0F"};